<template>
  <el-table :data="tableList" style="width:100%" ref='multipleTable'
  :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
  @selection-change="handleSelectionChange">
    <div slot="empty" class="no-data">
      <emptyContent/>
    </div>
    <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column>
    <el-table-column
      v-for="item in tableName"
      :key="item.prop"
      :label="item.label"
      :prop="item.prop"
      :sortable="item.sortable"
      align="center">
      <template slot-scope="scope">
        <template v-if="item.prop==='avg_score'">
          <span :class="getRightClass(scope.row[item.prop])">
            {{scope.row[item.prop]===-1?'--':scope.row[item.prop]+'%'}}
          </span>
        </template>
        <template v-else-if="item.prop==='avg_right_rate'">
            {{scope.row[item.prop]===-1?'--':scope.row[item.prop]+'%'}}
        </template>
        <template v-else-if="item.prop==='low_score_count'">
            {{scope.row[item.prop]===-1?'--':scope.row[item.prop]}}
        </template>
        <template slot-scope="scope" v-else>
          {{scope.row[item.prop]}}
        </template>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
      <el-button
        size="mini"
        type="text"
        @click="queryClassDetail(scope.$index, scope.row)">查看详情</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import storeCreator from '@/utils/store-creator';
import emptyContent from './empty-content.vue';

const CLASS_TYPE = 1;
export default {
  name: 'KnowledgeTable',
  components: {
    emptyContent,
  },
  data() {
    return {
      classType: CLASS_TYPE,
    };
  },
  props: {
    activeIndex: {
      type: [String, Number],
      default: 0,
    },
    tableList: {
      type: Array,
      default: () => [],
    },
    tableName: {
      type: Array,
      default: () => [],
    },
    knowledgeList: {
      type: Array,
      default: () => [],
    },
    basicInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    clearSelected() {
      this.$refs.multipleTable.clearSelection();
    },
    // 正答率样式添加
    getRightClass(value) {
      if (value === -1) {
        return 'default';
      }
      if (value >= 70) {
        return 'level2';
      }
      if (value >= 40) {
        return 'level1';
      }
      return 'level3';
    },
    queryClassDetail(index, row) {
      const store = storeCreator.create('pt');
      store.set('row', JSON.stringify(row));
      this.$router.push({
        path: '/pt/detailed',
        query: {
          classType: this.classType,
          classId: this.basicInfo.class_id,
          className: this.basicInfo.class_name,
          testName: this.basicInfo.test_name,
          testId: this.basicInfo.test_id,
          evaluateId: this.basicInfo.evaluate_id,
          subjectId: this.basicInfo.subject_id,
          subjectName: this.basicInfo.subject_name,
        },
      });
    },
    handleSelectionChange(val) {
      // console.log(val);
      if (this.activeIndex === 0) this.$emit('getLevelZero', val);
      if (this.activeIndex === 1) this.$emit('getLevelOne', val);
      if (this.activeIndex === 2) this.$emit('getLevelTwo', val);
      if (this.activeIndex === 3) this.$emit('getLevelThree', val);
      if (this.activeIndex === 4) this.$emit('getLevelFour', val);

      this.knowledgeList[this.activeIndex].num = val.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.no-data{
  line-height: 1.8;padding: 30px 0;
}

</style>
